import { render, staticRenderFns } from "./SpinnerComponent.vue?vue&type=template&id=08fe792c&lang=pug"
import script from "./SpinnerComponent.vue?vue&type=script&lang=ts"
export * from "./SpinnerComponent.vue?vue&type=script&lang=ts"
import style0 from "./SpinnerComponent.vue?vue&type=style&index=0&id=08fe792c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08fe792c')) {
      api.createRecord('08fe792c', component.options)
    } else {
      api.reload('08fe792c', component.options)
    }
    module.hot.accept("./SpinnerComponent.vue?vue&type=template&id=08fe792c&lang=pug", function () {
      api.rerender('08fe792c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Spinner/SpinnerComponent.vue"
export default component.exports